export * from './IconDrillingPartRightFilled';
